var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1229 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9-blue",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SSH-ROOT@SERVER_1",
    fontFamily: "BradleyHandITCTT-Bold, Bradley Hand",
    fontSize: 35,
    fontStyle: "expanded",
    fontWeight: "bold",
    letterSpacing: -0.35,
    fill: "#305B86"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 442.782977,
    y: 244.87048
  }, "SSH ROOT@SERVER_1")), /*#__PURE__*/React.createElement("g", {
    id: "boyarmsfolded_DL",
    transform: "translate(0.000000, 22.789088)",
    stroke: "#305B86",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8254822,19.8325102 C66.9364636,2.47865388 103.389656,-6.1371405 131.121753,4.97291411 C220.655044,40.8380942 171.692555,161.5285 81.9657366,149.54627 C21.4862953,141.472529 24.8174409,30.5676108 71.8487713,11.7261645",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3897448,421.896988 C61.5996093,421.896988 67.5828115,417.818871 67.5828115,414.824377 C67.5828115,411.829884 73.5225194,360.911659 74.3860744,347.987884 C75.0757968,337.618063 74.704133,305.446044 74.704133,301.772046 C74.704133,298.09805 76.3094035,296.873383 72.2062904,294.386911 C68.1031772,291.900442 11.0678251,268.190385 2.64372233,256.262698 C-3.92236887,246.96577 3.2063863,243.874296 8.19225986,239.402263 C13.1781334,234.930231 23.8678791,225.165741 32.2230537,218.166968 C38.6212109,212.810938 58.864515,193.166784 61.3318149,188.653517 C63.5972447,184.495322 79.5225441,184.824726 84.2496665,184.174473 C96.799251,182.459004 120.402143,177.13741 132.934905,180.987591 C140.471385,183.297698 192.276738,217.26207 196.807597,223.730374 C200.598268,229.146295 200.502939,226.669346 195.383292,235.178246 C190.616918,243.08823 183.240832,252.587217 175.917438,260.334637 C166.721138,270.067039 148.168765,283.392643 139.808774,292.418961 C133.371364,299.369461 131.09472,344.336526 131.773227,354.644347 C132.382195,363.89574 132.653604,400.367431 132.911549,405.419725 C133.421832,415.413084 129.309374,416.025002 138.174831,420.859117 C141.982324,422.933938 152.532706,418.424948 152.925231,420.859117",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0566638,284.049457 C67.8124335,256.613082 65.6903184,238.813415 65.6903184,230.650454 C65.6903184,222.487495 64.3314353,208.261978 61.613669,187.973906",
    id: "Path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.758932,284.049457 C138.54373,264.175376 139.93613,249.917581 139.93613,241.276073 C139.93613,232.634565 139.93613,214.867176 139.93613,187.973906",
    id: "Path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "key_DL",
    transform: "translate(345.663126, 165.858116)",
    stroke: "#305B86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("g", {
    id: "key"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2904335,133.100316 C52.82599,131.091159 36.2470254,136.615716 32.2214327,132.087113 C30.0469278,129.640898 35.4023358,53.059147 35.4023358,39.9612985",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9379325,43.2014037 C24.9186727,43.0814558 15.6353426,43.1426631 9.58468256,39.0232165 C-15.3970645,22.0149938 11.4127691,-10.0812186 55.876049,3.09680357 C81.8372786,10.79119 60.4465081,45.3784592 33.772191,39.4410353",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9288748,113.752206 C42.4874909,114.613939 48.21497,113.752206 50.7231174,113.752206 L35.9288748,113.752206 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8721432,93.1285596 C40.0019799,92.3100371 52.8806198,93.7853739 53.8933122,93.9630531",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "server",
    transform: "translate(988.568579, 0.000000)",
    stroke: "#305B86",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1647292,11.5696896 C75.8986088,10.699328 146.632488,9.8289664 217.366368,8.95860479",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3332365,434.626627 C85.0364784,434.585828 153.73972,434.54503 222.442962,434.504232",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.964534,0.254988751 C215.319577,381.578388 201.279097,234.052962 226.504238,444.139407",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0072657,125.342271 C96.2049857,125.505463 131.402706,125.668656 166.600426,125.831849",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0072657,93.1388912 C96.2049857,93.302084 131.402706,93.4652768 166.600426,93.6284696",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0072657,58.324427 C96.2049857,58.4876198 131.402706,58.6508126 166.600426,58.8140054",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7928019,384.474303 C80.0256997,367.604459 65.6887168,379.608942 84.0458336,394.357779 C95.3639986,403.451242 109.319988,374.834386 123.433355,382.688688 C130.803816,386.790461 134.137779,394.803327 141.035161,399.464241 C152.681381,407.334189 158.363626,371.75709 188.93744,391.603583",
    id: "Path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05955108,2.86607356 C5.81214429,399.641657 -11.8932248,253.258879 15.3179177,444.139407",
    id: "Path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow0003_DL",
    transform: "translate(288.226655, 44.719377)",
    stroke: "#305B86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6179766,299.451186 C116.525555,290.730853 176.303212,284.333686 218.950947,280.259685 C268.661321,275.511011 307.329877,272.750234 334.956617,271.977355 L324.751984,343.414662 L313.641194,399.966699 C400.314822,341.635892 466.464778,298.972777 512.091065,271.977355 C557.717352,244.981933 604.234621,220.983931 651.642872,199.983349 C621.142758,175.724733 584.282886,149.949103 541.063256,122.656455 C497.843626,95.3638053 429.141411,54.478321 334.956617,0 C341.421939,35.1391943 345.81948,60.5291141 348.14924,76.1697592 C350.479003,91.8104022 352.171581,107.305969 353.226978,122.656455 C322.535485,118.775568 281.620373,113.360793 230.481641,106.412132 C179.342908,99.4634682 102.515694,88.8795747 0,74.6604512 L0,74.6604512 C8.98741836,132.66951 13.4811264,174.443809 13.4811264,199.983349 C13.4811264,225.52289 8.98741836,260.18667 0,303.974691",
    id: "arrow0003"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.b4c4a2c7188d83721c6620c477ebec6c.svg";
export { ForwardRef as ReactComponent };